<script setup>
import { useRoute,useRouter } from 'vue-router'
import axios from "axios"
const route = useRoute()
const router = useRouter()
// const productId = route.params.id
import { ref, onMounted } from 'vue'
import Swal from "sweetalert2";


const user = ref({})
const loading = ref(false)
const error = ref('')
// import {inject, ref} from "vue";

// const count2 = ref(0)
// const vv= inject('mess')
// function incress() {
//   count2.value = count2.value + 2
// }

onMounted(async () => {
  loading.value = true
  try {
    const response = await axios.get("https://picsum.photos/id/"+route.params.id+"/info")
    user.value =(response.data)
  } catch (err) {
    error.value = 'خطا در دریافت اطلاعات'
    console.error(err)
  } finally {
    loading.value = false
  }
})

function EditProduct() {
  console.log("Edit",route.params.id)
  router.push({ path: '/Editproduct', query: { id: route.params.id } })
}

async function DeleteProduct() {
  console.log("Delete",route.params.id)
  // router.push({ path: '/Deleteproduct', query: { id: route.params.id } })

  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!"
  }).then((result) => {
    if (result.isConfirmed) {
      Swal.fire({
        title: "Deleted!",
        text: "Your file has been deleted.",
        icon: "success"
      });
    }
  });




  try {
    const response = await axios.DELETE("https://jsonplaceholder.typicode.com/posts/"+route.query.id)
    // posts.value =(response.data)
    console.log(response)

    if (response.status === 200){
      Swal.fire({
        title: "Good job!",
        text: "محصول با موفقیت حذف شد.",
        icon: "success",
        footer: '<a href="/products">لیست کل محصولات</a>'
      });
    }
    else {
      Swal.fire({
        title: 'Error!',
        text: 'Do you want to continue',
        icon: 'error',
        confirmButtonText: 'Cool'
      })
    }

  } catch (err) {
    // error.value = 'خطا در دریافت اطلاعات'
    Swal.fire({
      title: 'Error!',
      text: 'خطا در دریافت اطلاعات',
      icon: 'error',
      confirmButtonText: 'Cool'
    })
    console.error(err)
  } finally {
    // loading.value = false
  }
}



</script>

<template>
<!--  <h1>product.id</h1>
  <p>{{productId}}</p>
  <p>{{users}}</p>
  <p>{{users.author}}</p>
  <p>{{users.download_url}}</p>
  <img :src="users.download_url" :alt="users.id" class="card-img-top" width="200" height="200" >-->

  <div class="row row-cols-1 row-cols-sm-2  row-cols-md-3 row-cols-lg-4 row-cols-xl-4 g-4">
  <div class="col " >
    <div class="card h-100">
      <img :src="user.download_url" :alt="user.id" class="card-img-top"  >
      <div class="card-body">
        <h5 class="card-title">
          <RouterLink class=" " :to="'/product/'+user.id" > {{ user.author }} ({{ user.id }})</RouterLink>

        </h5>
        <p class="card-text">This is a longer card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
      </div>
      <div class="card-footer">
        <button class="btn btn-link btn-outline-success float-start" @click="EditProduct">Edit</button>
        <button class="btn btn-link btn-outline-danger float-end" @click="DeleteProduct">Delete</button>

      </div>
    </div>
  </div>
  </div>





</template>

<style scoped>

</style>